import React from 'react';
import { Outlet } from 'react-router-dom';

const SponsersHome = () => {
  return (
    <section className="app-route">
      <Outlet />
    </section>
  );
};

export default SponsersHome;